import { SET_PERIODS, DELETE_PERIOD } from '../types'

const initialState = []

export const periodsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERIODS:
      return action.payload

    case DELETE_PERIOD:
      return state.filter( period => period.slug !== action.payload )
  
    default:
      return state
  }
}